import { pushToGtmDataLayer } from '@/lib/tracking/services/tracking.gtm'

export type AuthenticationEventAction =
  | 'début parcours'
  | 'connexion compte'
  | 'connexion - page sélection compte client multicompte'
  | 'déconnexion compte'
  | 'création de compte'
  | 'doc'
  | 'doa'
  | 'multicompte - ajout compte'

export type AuthenticationTrackingEvent = {
  action: AuthenticationEventAction
  label: string
}

export function pushAuthenticationTrackingEvent({ action, label }: AuthenticationTrackingEvent) {
  pushToGtmDataLayer({
    event: 'gaEvent',
    eventCategory: 'parcours DOA DOC connexion',
    eventAction: action,
    eventLabel: label,
  })
}
